import React from 'react'
import Card from './Card'
import pediatric from "./images/pediatric.png"
import immunization from "./images/immunization.png"
import newborn from "./images/newborn.png"
function AllCards() {
  return (
    <div>
        <div id="all-cards">
    <Card title="Pediatric Care" color="red" image={pediatric}/>
    <Card title="Immunization" color="blue" image={immunization}/>
    <Card title="Newborn Care" color="green" image={newborn}/>
    </div>
    </div>
  )
}

export default AllCards